import React from 'react'
import { motion } from "framer-motion"
import styles from './AboutUs.module.scss'
import image from '../../image/AboutUs/img.webp'

const imageAnimation = {
    hidden: {
        scale: 0,
        opacity: 0,
    },

    visible: {
        scale: 1,
        opacity: 1,
        transition: { duration: .8 }
    }
}

const textAnimation = {
    hidden: {
        x: 500,
        opacity: 0,
    },

    visible: {
        x: 0,
        opacity: 1,
        transition: { duration: .6 }
    }
}

export const AboutUs = ({isOpen}) => {

    return (
        <motion.section 
            className={styles.main} 
            initial='hidden'
            whileInView='visible'
            viewport={{amount: 0.1, once: true}}
            id='AboutUs'             
            >
            <div className={styles.container}>
                <motion.img className={styles.image} src={image} alt='металл' variants={imageAnimation}/>
                <motion.div className={styles.box_info} variants={textAnimation}>
                        <h2 className={styles.title}>О компании <span>ТАВРИЯ&#160;ДС</span></h2>
                        <p className={styles.text}>&#8195;Уже более трех лет мы успешно осуществляем дорожно-строительные работы любой сложности и комплексное благоустройство различных частных и муниципальных территорий .</p>
                        <p className={styles.text}>Основными принципами нашей деятельности является: надёжность и стабильность в работе с нашими клиентами, ответственный подход наших сотрудников к выполнению своей работы, ориентированность на долгосрочное сотрудничество с партнёрами компании.</p>
                        <p className={styles.text}>Главный актив компании ТАВРИЯ ДС - люди. Квалифицированный персонал компании - результат качественного отбора и непрерывного обучения кадров. Мы уделяем особое внимание сотрудникам нашей компании, поскольку именно они обеспечивают качество работы с нашими клиентами и постоянство наших клиентов в выборе нашей компании как благонадёжного партнера.</p>
                        <p className={styles.text}>Мы готовы предоставить вам консультацию и помощь в выборе оптимального решения для вашего объекта. Свяжитесь с нами, чтобы узнать больше о наших услугах и получить профессиональную помощь в решении ваших задач по асфальтированию.</p>
                        <div className={styles.box_button}>
                            <a className={styles.button} href="tel:+79690101605" target='_blank' rel='noopener noreferrer'>получить консультацию <span className={styles.glare}></span></a>
                        </div>
                    </motion.div>
            </div>
        </motion.section>
        
        
    )
}